import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  ExternalDataService,
  GenerateInvoicesResultDto,
} from '../../../services/externalDataService.service';

@Component({
  selector: 'app-partner-monthly-invoice-generate',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './partner-monthly-invoice-generate.component.html',
  styleUrl: './partner-monthly-invoice-generate.component.css',
})
export class PartnerMonthlyInvoiceGenerateComponent {
  year = new Date().getFullYear();
  month = new Date().getMonth() + 1;
  loading = false;
  errorMessage = '';
  result: GenerateInvoicesResultDto | null = null;

  readonly monthOptions = Array.from({ length: 12 }, (_, i) => i + 1);
  readonly monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  constructor(private externalData: ExternalDataService) {}

  get yearOptions(): number[] {
    const y = new Date().getFullYear();
    return [y - 1, y, y + 1];
  }

  generate(): void {
    this.errorMessage = '';
    this.result = null;
    if (!this.year || this.month < 1 || this.month > 12) {
      this.errorMessage = 'Please select a valid year and month.';
      return;
    }

    this.loading = true;
    this.externalData
      .generatePartnerMonthlyInvoices(this.year, this.month)
      .subscribe({
        next: (r) => {
          this.result = r;
          this.loading = false;
        },
        error: (error) => {
          console.error('generatePartnerMonthlyInvoices', error);
          const body = error?.error;
          this.errorMessage =
            body?.detail ||
            body?.title ||
            'Could not generate invoices. Please try again.';
          this.loading = false;
        },
      });
  }
}
